/**
 * @return {Promise<void>}
 */
module.exports = async function waitFor300Milliseconds() {
    await new Promise(resolve => setTimeout(resolve, 300));
}